import { useSearchQueryFilter } from '@aibees/elephant/hooks/use-search-query-filter';
import { decodeQueryParamValues } from '@aibees/shared/utils/url';
import { useMemo } from 'react';

export function useDecodedQueryParamFilterValues(
  field: string,
  customValue?: string
) {
  const { params } = useSearchQueryFilter({ select: [field] });
  return useMemo(() => {
    const raw = customValue ?? params[field];
    if (raw === '') return [];
    return decodeQueryParamValues(raw);
  }, [field, params, customValue]);
}
